import React, { Component } from 'react';
import { Grid } from 'react-bootstrap'
import './style.css'

class Footer extends Component {
    
    shouldComponentUpdate(nextProps, nextState){
        return false;
    }

    render() {
        return (
            <div className="footer dotted-spaced">
                <Grid>
                    <div className="copyright-text" style={{}}>Copyright © 2025 Great Talent Award Limited</div>
                </Grid>                
            </div>
        );
    }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/common/footer/index.js